import * as React from 'react';

interface divProps {
  style: React.CSSProperties,
  children?: React.ReactChild
}

class NotFoundPage extends React.Component<any, any> {
  render() {
    const errPageProps: divProps = {
      style: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 10000,
        background: '#fff',
      },
    };
    return (
      <div {...errPageProps}>
        <h1 style={{ textAlign: "center", marginTop: 50, fontSize: 52, }}>404</h1>
      </div>
    );
  }
}

export default NotFoundPage;